var _excluded = ["className"],
    _excluded2 = ["Component", "Parent"],
    _excluded3 = ["Component", "Parent"];

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/*
 * Copyright (c) 2021 Anton Bagdatyev (Tonix)
 *
 * Permission is hereby granted, free of charge, to any person
 * obtaining a copy of this software and associated documentation
 * files (the "Software"), to deal in the Software without
 * restriction, including without limitation the rights to use,
 * copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the
 * Software is furnished to do so, subject to the following
 * conditions:
 *
 * The above copyright notice and this permission notice shall be
 * included in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
 * OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
 * NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
 * HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
 * WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
 * FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
 * OTHER DEALINGS IN THE SOFTWARE.
 */
import { trim, isArray, isUndefined, isEmpty, compose } from "js-utl";
/**
 * React JS utility functions.
 */

/**
 * Returns a class name string.
 *
 * @param {*} componentClassName Default class name of a component (a string) or a falsy value which evaluates to an empty string.
 * @param {...*} classNames Additional, optional list of strings of class names or falsy values to ignore.
 * @return {string} The class name string.
 */

export function classNames(componentClassName) {
  for (var _len = arguments.length, classNames = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    classNames[_key - 1] = arguments[_key];
  }

  return classNames.reduce(function (componentClassName, className) {
    return trim("".concat(componentClassName || "", " ").concat(className || ""));
  }, componentClassName);
}
/**
 * Merges a component's class name.
 *
 * @deprecated since version 1.17.0 (will be removed in a next major version, use "classNames()" instead)
 *
 * @param {string} componentClassName Component's class name.
 * @param {Object} props Properties.
 * @return {Object} The merged properties.
 */

export function mergeClassNameProp(componentClassName, props) {
  var className = props.className,
      remaining = _objectWithoutProperties(props, _excluded);

  return _objectSpread({
    className: classNames(componentClassName, className)
  }, remaining);
}
/**
 * Returns the name of a React component.
 *
 * @param {Object} reactComponentInstance An instance of a React component.
 * @return {string|undefined} The React component's name, or "undefined" if the name is unknown.
 */

export function reactComponentName(reactComponentInstance) {
  return reactComponentInstance.constructor.displayName || reactComponentInstance.constructor.name || void 0;
}
/**
 * Gets a React component's display name.
 *
 * @param {Function} Component A component.
 * @return {string} Its name or "Component" if unknown.
 */

export function getDisplayName(Component) {
  return Component.displayName || Component.name || _typeof(Component) === "object" && getDisplayName(Component.type) || "Component";
}
/**
 * Returns an array of mappable children if the given children
 * parameter is not falsy.
 *
 * @private
 *
 * @param {*} children The given children.
 * @param {(children: Array) => Array} fn A callback to map children returning the mapped children
 *                                        if the given "children" is not falsy.
 */

var childrenMap = function childrenMap(children, fn) {
  if (!isArray(children)) {
    if (!children) {
      return children;
    }

    children = [children];
  }

  return fn(children);
};
/**
 * Map React children like "React.Children.map()", but without changing children keys.
 *
 * @param {*} children React children (usually the value of "props.children").
 * @param {Function} fn Function to call which will receive each child and its corresponding index as argument.
 * @return {Array} An array of mapped children.
 */


export var reactChildrenMap = function reactChildrenMap(children, fn) {
  return childrenMap(children, function (children) {
    return children.map(fn);
  });
};
/**
 * Map React children like "reactChildrenMap", but flattening the given children before mapping.
 *
 * @param {*} children React children (usually the value of "props.children").
 * @param {Function} fn Function to call which will receive each child and its corresponding index as argument.
 * @param {number} [depth] The depth of the flattening. Defaults to 1.
 * @return {Array} An array of mapped children.
 */

export var reactChildrenFlatMap = function reactChildrenFlatMap(children, fn) {
  var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  return childrenMap(children, function (children) {
    return children.flat(depth).map(fn);
  });
};
/**
 * Returns a key/child tuple function.
 *
 * @private
 *
 * @param {Function} fn Function to call which will receive two parameters:
 *
 *                          - key: The current key;
 *                          - child: The current child;
 *
 * @return {(current: *) => *} A function returning the mapped child.
 */

var childrenKeyChildTupleFn = function childrenKeyChildTupleFn(fn) {
  return function (current) {
    var key, child;

    if (isArray(current)) {
      var _current = _slicedToArray(current, 2);

      key = _current[0];
      child = _current[1];
    } else {
      child = current;
      key = child.key;
    }

    return fn(key, child);
  };
};
/**
 * Map React children like "React.Children.map()", but without changing children keys
 * as well as accepting a "[key, child]" tuple as a child and passing the current key and child
 * parameter to the provided callback function.
 *
 * @param {*} children React children (usually the value of "props.children").
 * @param {Function} fn Function to call which will receive two parameters:
 *
 *                          - key: The current key;
 *                          - child: The current child;
 *
 * @return {Array} An array of mapped children.
 */


export var reactChildrenKeyChildTupleMap = function reactChildrenKeyChildTupleMap(children, fn) {
  return reactChildrenMap(children, childrenKeyChildTupleFn(fn));
};
/**
 * Map React children like "reactChildrenKeyChildTupleMap", but flattening the given children before mapping.
 *
 * @param {*} children React children (usually the value of "props.children").
 * @param {Function} fn Function to call which will receive two parameters:
 *
 *                          - key: The current key;
 *                          - child: The current child;
 *
 * @return {Array} An array of mapped children.
 */

export var reactChildrenKeyChildTupleFlatMap = function reactChildrenKeyChildTupleFlatMap(children, fn) {
  return reactChildrenFlatMap(children, childrenKeyChildTupleFn(fn));
};
/**
 * Generates a new ref callback.
 *
 * @param {Object} ref A ref object.
 * @param {*} ref.current The mutable value of the ref.
 * @param {string} prop A property to pick from the value passed to the ref callback.
 * @return {Function} The new ref callback.
 */

export var refCallback = function refCallback(ref) {
  var prop = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : void 0;
  return function (value) {
    return ref.current = prop ? value ? value[prop] : null : value;
  };
};
/**
 * Tests if the given value has a React component name property
 * (either a "name" or a "displayName" string property with the first character
 * being a capital letter).
 *
 * @param {*} fn A value.
 * @return {boolean} True if the given value has a valid React component name,
 *                   false otherwise.
 */

export var isWithReactComponentName = function isWithReactComponentName(fn) {
  return !!(fn && (!isEmpty(fn.name) && fn.name[0] === fn.name[0].toUpperCase() || !isEmpty(fn.displayName) && fn.displayName[0] === fn.displayName[0].toUpperCase()));
};
/**
 * Tests if the given value is a function with a valid React component name.
 *
 * @param {*} fn A value.
 * @return {boolean} True if the given value is a function with a valid React component name,
 *                   false otherwise.
 */

export var isFnWithComponentName = function isFnWithComponentName(fn) {
  return typeof fn === "function" && isWithReactComponentName(fn);
};
/**
 * Tests if a value is a React builtin HOC (e.g. a component returned by "React.memo()").
 *
 * @param {*} Component The value.
 * @return {boolean} True if the given value is a React HOC.
 */

export var isReactHOC = function isReactHOC(Component) {
  return _typeof(Component) === "object" && (Object.prototype.hasOwnProperty.call(Component, "$$typeof") && [_typeof(Symbol("")), _typeof("")].indexOf(_typeof(Component.$$typeof)) > -1 || isWithReactComponentName(Component) || isReactComponent(Component.type));
};
/**
 * Private helper for composing behaviour when testing possible React components.
 *
 * @private
 */

var withAncestorHasComponentName = function withAncestorHasComponentName() {
  var ancestorHasComponentName = false;
  return function (fn) {
    return function (_ref) {
      var Component = _ref.Component,
          _ref$Parent = _ref.Parent,
          Parent = _ref$Parent === void 0 ? void 0 : _ref$Parent,
          props = _objectWithoutProperties(_ref, _excluded2);

      ancestorHasComponentName = ancestorHasComponentName || isWithReactComponentName(Parent);
      return fn(_objectSpread(_objectSpread({}, props), {}, {
        Component: Component,
        ancestorHasComponentName: ancestorHasComponentName
      }));
    };
  };
};
/**
 * Private helper for composing behaviour when testing possible React components.
 *
 * @private
 */


var withAncestorIsBuiltinReactHOC = function withAncestorIsBuiltinReactHOC() {
  var ancestorIsBuiltinReactHOC = false;
  return function (fn) {
    return function (_ref2) {
      var Component = _ref2.Component,
          _ref2$Parent = _ref2.Parent,
          Parent = _ref2$Parent === void 0 ? void 0 : _ref2$Parent,
          props = _objectWithoutProperties(_ref2, _excluded3);

      ancestorIsBuiltinReactHOC = ancestorIsBuiltinReactHOC || isReactHOC(Parent);
      return fn(_objectSpread(_objectSpread({}, props), {}, {
        Component: Component,
        ancestorIsBuiltinReactHOC: ancestorIsBuiltinReactHOC
      }));
    };
  };
};
/**
 * Composed behaviours when testing ancestors.
 *
 * @private
 *
 * @param {(props: Object) => boolean} fn
 */


var withComposedAncestorTests = function withComposedAncestorTests(fn) {
  return compose(withAncestorIsBuiltinReactHOC(), withAncestorHasComponentName())(fn);
};
/**
 * Tests if the given value is a valid React functional component.
 *
 * @param {*} Component The value.
 * @return {boolean} True if the value is a React functional component, false otherwise.
 */


export function isFunctionalComponent(Component) {
  var testComponent = withComposedAncestorTests(function (_ref3) {
    var Component = _ref3.Component,
        ancestorHasComponentName = _ref3.ancestorHasComponentName,
        ancestorIsBuiltinReactHOC = _ref3.ancestorIsBuiltinReactHOC;

    if (!(Component.prototype && Component.prototype.isReactComponent) && (isFnWithComponentName(Component) || typeof Component === "function" && (ancestorHasComponentName || ancestorIsBuiltinReactHOC))) {
      return true;
    } else if (isReactHOC(Component)) {
      return testComponent({
        Component: Component.type,
        Parent: Component
      });
    }

    return false;
  });
  return testComponent({
    Component: Component
  });
}
/**
 * Tests if the given value is a valid React class component.
 *
 * @param {*} Component The value.
 * @return {boolean} True if the value is a React class component, false otherwise.
 */

export function isClassComponent(Component) {
  var testComponent = withComposedAncestorTests(function (_ref4) {
    var Component = _ref4.Component,
        ancestorHasComponentName = _ref4.ancestorHasComponentName,
        ancestorIsBuiltinReactHOC = _ref4.ancestorIsBuiltinReactHOC;
    return !!(Component.prototype && Component.prototype.isReactComponent && (ancestorHasComponentName || ancestorIsBuiltinReactHOC || isFnWithComponentName(Component))) || isReactHOC(Component) && isClassComponent(Component.type);
  });
  return testComponent({
    Component: Component
  });
}
/**
 * Tests if the given value is a valid React component.
 *
 * @param {*} value A value.
 * @return {boolean} True if the given value is a valid React component, false otherwise.
 */

export function isReactComponent(Component) {
  return isFunctionalComponent(Component) || isClassComponent(Component) || isReactHOC(Component);
}
/**
 * Returns a default value.
 *
 * @param {*} [defaultValue] A default value.
 * @param {*} [valueIfDefaultValueIsUndefined] A value to return if the given default value is "undefined".
 * @return {*} A default value.
 */

export function defaultVal() {
  var defaultValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : void 0;
  var valueIfDefaultValueIsUndefined = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : void 0;

  if (defaultValue) {
    return defaultValue;
  }

  if (isUndefined(defaultValue)) {
    return valueIfDefaultValueIsUndefined;
  } else {
    return !defaultValue ? void 0 : defaultValue;
  }
}
/**
 * Checks whether the given value is a controlled value or not.
 * If the value is a controlled value, it can be used in a controlled component.abs
 *
 * @see https://stackoverflow.com/questions/37427508/react-changing-an-uncontrolled-input#answer-37427596
 * @see https://github.com/facebook/react/blob/master/packages/react-dom/src/client/ReactDOMInput.js#L40
 *
 * @param {*} value The given value.
 * @return {boolean} True if the given value is a controlled value, i.e. it can be used in a controlled component,
 *                   false otherwise.
 */

export function isControlledValue(value) {
  return value != null;
}
//# sourceMappingURL=utils.js.map